import { getSessionLocalStorage } from 'common/utils/helpers/session';

import initializeForm from './initializeForm';
import openModal from './openModal';
import setIsNewRecord from './setIsNewRecord';

export default () => (dispatch) => {
    const session = getSessionLocalStorage();
    dispatch(
        initializeForm({
            installer: session.id,
        }),
    );
    dispatch(setIsNewRecord(true));
    dispatch(openModal(true));
};
